var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "btn input-margin",
    class: _vm.buttonClass,
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.typeButton
    },
    on: {
      "click": _vm.click
    }
  }, [_c('span', {
    staticClass: "container-button"
  }, [_vm._t("icon", null, {
    "size": 18
  }), _vm._t("default")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };